import { render, staticRenderFns } from "./ProductCardStyleTwo.vue?vue&type=template&id=44bc9263&scoped=true"
import script from "./ProductCardStyleTwo.vue?vue&type=script&lang=js"
export * from "./ProductCardStyleTwo.vue?vue&type=script&lang=js"
import style0 from "./ProductCardStyleTwo.vue?vue&type=style&index=0&id=44bc9263&prod&lang=css"
import style1 from "./ProductCardStyleTwo.vue?vue&type=style&index=1&id=44bc9263&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_react-dom@19.2.4_react@18.3.1_vue-templat_zb2mrinni5lndihrytzfraeym4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bc9263",
  null
  
)

export default component.exports